import {NgxIndexedDBModule} from 'ngx-indexed-db';
import {CommonModule, DatePipe} from '@angular/common';
import {CUSTOM_ELEMENTS_SCHEMA, NgModule} from '@angular/core';
import {ReactiveFormsModule} from '@angular/forms';
import {MatButtonModule} from '@angular/material/button';
import {MatCardModule} from '@angular/material/card';
import {MatCheckboxModule} from '@angular/material/checkbox';
import {MatDividerModule} from '@angular/material/divider';
import {MatExpansionModule} from '@angular/material/expansion';
import {MatFormFieldModule} from '@angular/material/form-field';
import {MatIconModule} from '@angular/material/icon';
import {MatInputModule} from '@angular/material/input';
import {MatRadioModule} from '@angular/material/radio';
import {MatSelectModule} from '@angular/material/select';
import {MatStepperModule} from '@angular/material/stepper';
import {MatTableModule} from '@angular/material/table';
import {MatToolbarModule} from '@angular/material/toolbar';
import {MatTooltipModule} from '@angular/material/tooltip';
import {RouterModule} from '@angular/router';
import {TranslateModule} from '@ngx-translate/core';
import {
  ObAlertModule,
  ObButtonModule,
  ObIconModule,
  ObMasterLayoutModule,
  ObPopoverModule,
  ObSpinnerModule,
  ObliqueModule
} from '@oblique/oblique';

import {TemostaDropdownComponent} from './components/dropdown/tmst-dropdown.component';
import {InfoBoxExportDatalistComponent} from './components/info-box-export-datalist/info-box-export-datalist.component';
import {InfoBoxComponent} from './components/info-box/info-box.component';
import {SelectCheckAllComponent} from './components/select-check-all/select-check-all.component';
import {AgeValidatorDirective} from './directives/age-validator.directive';
import {CardFactoryDirective} from './directives/card-factory.directive';
import {NumberOnlyDirective} from './directives/number-only.directive';
import {DragDropDirective} from './pipes/drag-drop.directive';
import {DynamicAppTitlePipe} from './pipes/dynamic-app-title/dynamic-app-title.pipe';
import {FiveDigitDecimaNumberDirective} from './pipes/five-digit-decima-number.directive';
import {GenderRenderDirective} from './pipes/gender-render.directive';
import {GenderSymbolHtmlPipe} from './pipes/gender-symbol-html.pipe';
import {GenderSymbolUtf8Pipe} from './pipes/gender-symbol-utf8.pipe';
import {NumberFormatPipe} from './pipes/number-format.pipe';
import {OnlyNumberDirective} from './pipes/only-number.directive';
import {RetrieveCaptionFromArrayPipe} from './pipes/retrieve-caption-from-array.pipe';
import {RisingFallingArrowPipe} from './pipes/rising-falling-arrow.pipe';
import {SummaryLabelPipe} from './pipes/summary-label.pipe';
import {YesnoPipe} from './pipes/yesno.pipe';
import {TableChartDownloadButtonComponent} from './components/table-chart-download-button/table-chart-download-button.component';
import {temostaDbConfig} from './services/storage/indexed-db-storage.service';
import {LinkPartPipe} from './pipes/link-part.pipe';
import {RetrievevalueByIndexPipe} from './pipes/retrievevalue-by-index.pipe';
import {BoolToYesNoPipe} from './pipes/bool-to-yes-no.pipe';
import {IdToLaufnummerPipe} from './pipes/id-to-laufnummer.pipe';
import {IdToLaufnummernPipe} from './pipes/id-to-laufnummern.pipe';
import {GenderPipe} from './pipes/gender.pipe';
import {ReplaceNullOrUndefinedToPipe} from './pipes/replace-null-or-undefined-to.pipe';
import {IdToLnReturnLnAndFncnamePipe} from './pipes/id-to-ln-return-ln-and-fncname.pipe';
import {ProgressDialogComponent} from './components/progress-dialog/progress-dialog.component';
import {MatProgressBarModule} from '@angular/material/progress-bar';
import {ReplaceTotalRobustScoreToPipe} from './pipes/replace-total-robust-score-to.pipe';
import {SwissCurrencyPipe} from './pipes/swiss-currency.pipe';
import {CellStatusStylePipe} from './pipes/cell-status-style.pipe';
import {DynamicCellStatusTooltipPipe} from './pipes/dynamic-cell-status-tooltip.pipe';

@NgModule({
  declarations: [
    DragDropDirective,
    NumberOnlyDirective,
    AgeValidatorDirective,
    FiveDigitDecimaNumberDirective,
    SummaryLabelPipe,
    SelectCheckAllComponent,
    TemostaDropdownComponent,
    YesnoPipe,
    NumberFormatPipe,
    OnlyNumberDirective,
    RetrieveCaptionFromArrayPipe,
    InfoBoxExportDatalistComponent,
    GenderSymbolHtmlPipe,
    GenderSymbolUtf8Pipe,
    RisingFallingArrowPipe,
    GenderRenderDirective,
    InfoBoxComponent,
    DynamicAppTitlePipe,
    CardFactoryDirective,
    TableChartDownloadButtonComponent,
    LinkPartPipe,
    RetrievevalueByIndexPipe,
    BoolToYesNoPipe,
    IdToLaufnummerPipe,
    IdToLaufnummernPipe,
    GenderPipe,
    ReplaceNullOrUndefinedToPipe,
    ReplaceTotalRobustScoreToPipe,
    IdToLnReturnLnAndFncnamePipe,
    ProgressDialogComponent,
    SwissCurrencyPipe,
    CellStatusStylePipe,
    DynamicCellStatusTooltipPipe
  ],
  imports: [
    CommonModule,
    RouterModule,
    TranslateModule,
    ReactiveFormsModule,
    ObMasterLayoutModule,
    ObSpinnerModule,
    ObPopoverModule,

    ObButtonModule,
    MatCardModule,
    MatButtonModule,
    MatIconModule,
    MatTableModule,
    MatSelectModule,
    MatFormFieldModule,
    MatStepperModule,
    MatInputModule,
    MatCheckboxModule,
    MatExpansionModule,
    MatDividerModule,
    MatRadioModule,
    MatToolbarModule,
    MatTooltipModule,
    MatProgressBarModule,
    NgxIndexedDBModule.forRoot(temostaDbConfig),
    ObAlertModule
  ],
  exports: [
    CommonModule,
    ObliqueModule,
    RouterModule,
    TranslateModule,
    ReactiveFormsModule,
    ObMasterLayoutModule,
    ObSpinnerModule,
    ObPopoverModule,
    ObIconModule,
    ObButtonModule,
    MatCardModule,
    MatButtonModule,
    MatIconModule,
    MatStepperModule,
    MatInputModule,
    MatTableModule,
    MatSelectModule,
    MatTooltipModule,
    MatFormFieldModule,
    MatProgressBarModule,
    DragDropDirective,
    MatCheckboxModule,
    MatExpansionModule,
    MatDividerModule,
    MatRadioModule,
    MatToolbarModule,
    NumberOnlyDirective,
    FiveDigitDecimaNumberDirective,
    SummaryLabelPipe,
    SelectCheckAllComponent,
    TemostaDropdownComponent,
    YesnoPipe,
    NumberFormatPipe,
    OnlyNumberDirective,
    RetrieveCaptionFromArrayPipe,
    InfoBoxExportDatalistComponent,
    GenderSymbolHtmlPipe,
    GenderSymbolUtf8Pipe,
    RisingFallingArrowPipe,
    GenderRenderDirective,
    InfoBoxComponent,
    DynamicAppTitlePipe,
    TableChartDownloadButtonComponent,
    LinkPartPipe,
    RetrievevalueByIndexPipe,
    BoolToYesNoPipe,
    IdToLaufnummerPipe,
    IdToLaufnummernPipe,
    GenderPipe,
    ReplaceNullOrUndefinedToPipe,
    ReplaceTotalRobustScoreToPipe,
    IdToLnReturnLnAndFncnamePipe,
    SwissCurrencyPipe,
    CellStatusStylePipe,
    DynamicCellStatusTooltipPipe,
    ObAlertModule
  ],
  providers: [DatePipe],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
// eslint-disable-next-line @typescript-eslint/no-extraneous-class
export class SharedModule {}
